export default "__VITE_ASSET__DHZFiv0D__"